import { useState, useEffect } from 'react';

interface UseDataProps {
	dataIn: any;
}
export const useData = ({ dataIn }: UseDataProps): JSX.Element => {
	const [data, setData] = useState(dataIn);
	useEffect(() => {
		dataIn.map((d: any) => {
			d.count = +d.count;
			d.timestamp = new Date(d.timestamp);
			return d;
		});

		setData(dataIn);
	}, [dataIn]);

	return data;
};